import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function PricingSection() {
  return <section id="offer" aria-labelledby="offer-title" className="scroll-mt-9 bg-brand-alt px-4 py-12 md:py-20" data-id="element-157" data-mp="19jxdvgf8bdcx">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-158" data-mp="1eg5qam21ksge">
        <p className="mb-3 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal" data-id="element-159" data-mp="1ja0dhzguvpk8">OFFERTA DI LANCIO</p>
        <h2 id="offer-title" className="mb-12 text-3xl font-extrabold tracking-tight text-brand-primary md:text-4xl" data-id="element-160" data-mp="1na0rxk3yg0ra">
          🏷 Offerta Speciale di Lancio
        </h2>
        <div className="relative mx-auto max-w-xl rounded-[20px] border-2 border-brand-accent bg-brand-alt p-6 pt-10 shadow-lg md:p-10 md:pt-12" data-id="element-161" data-mp="1x8gmjx26xs5j">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-brand-accent px-5 py-2 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-162" data-mp="225qi7ug6b01t">
            EDUCAZIONE FISICA PRONTA™
          </div>
          <div className="space-y-4 text-left" data-id="element-163" data-mp="1mhpze74l5af9">
            <PriceLine label="8 Volumi Completi" price="97 €" data-id="element-164" data-mp="1mihjolsqflq8" />
            <PriceLine label="5 Bonus Esclusivi" price="128 €" data-id="element-165" data-mp="1hodfuberjttd" />
            <div className="flex items-center justify-between border-t border-brand-sand pt-5 text-sm font-bold" data-id="element-166" data-mp="1cqbsvfe7vacm">
              <span data-id="element-167" data-mp="17stjjnwaet43">TOTALE VALORE</span>
              <span className="text-brand-gray line-through" data-id="element-168" data-mp="17ppb2ebshb7m">225 €</span>
            </div>
          </div>
          <div className="my-8 border-y border-brand-sand py-7" data-id="element-169" data-mp="25d6fahulgjsq">
            <p className="text-xs font-extrabold uppercase tracking-[0.16em] text-brand-teal" data-id="element-170" data-mp="20hqzhkd10dto">SOLO OGGI</p>
            <p className="mt-2 font-display text-6xl font-extrabold tracking-tight text-brand-accent md:text-7xl" data-id="element-171" data-mp="1vfrygh4rdszw">
              19 <span className="text-2xl" data-id="element-172" data-mp="1rhu83az950ux">EUR</span>
            </p>
            <p className="mt-2 text-xs text-brand-gray" data-id="element-173" data-mp="k2z7h8jsl8kw">(pagamento unico)</p>
          </div>
          <CTAButton target="checkout" className="w-full py-5 text-sm md:text-base" data-id="element-174" data-mp="fzjcegndfgab" />
          <p className="mt-5 text-xs font-bold text-brand-gray" data-id="element-175" data-mp="hhi41d8rmwj1">
            Pagamento unico. Nessun abbonamento. Accesso immediato.
          </p>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between gap-4 border-b border-brand-sand pb-4 text-sm" data-id="element-176" data-mp="cievhitku86b">
      <span className="font-medium" data-id="element-177" data-mp="3uwxvfuvgdc5q">{label}</span>
      <span className="whitespace-nowrap font-bold text-brand-primary" data-id="element-178" data-mp="3uv3706kz31ww">{price}</span>
    </div>;
}